<app-form-min-dash></app-form-min-dash>
<div class="grid-container">
    <mat-grid-list cols="{{ ( cardLayout | async )?.columns }}" rowHeight="200px">
        <!--Mini Cards RealTime Stats-->
        <mat-grid-tile *ngFor="let mc of getMiniCardData()" [colspan]="( cardLayout | async )?.miniCard.cols"
            [rowspan]="( cardLayout | async )?.miniCard.rows">
            <app-mini-card [title]="mc.title" [icon]="mc.icon" [textValue]="mc.textValue" [value]="mc.value"
                [subtitle]="mc.subtitle" [isPercent]="mc.isPercent" [color]="mc.color"></app-mini-card>
        </mat-grid-tile>
    </mat-grid-list>
</div>

<div class="row marl100 mart60">
    <div class="col-6 m6 s12 mart10">
        <div class="mat-elevation-z4 white dashh1">
            <div class="row dashrowfix">
                <div class="col m12 s12 martneg10">
                    <h5 class="white-text">
                        <span class="col">Place Libre / Occupé </span>
                    </h5>
                </div>
            </div>
            <div class="white">
                <chart class="dashchart" type="bar" [data]="stackedBarPlaceData" [options]="stackedBaroptions"></chart>
            </div>
        </div>
    </div>
    <div class="col-6 m6 s12 mart10">
        <div class="mat-elevation-z4 white dashh1">
            <div class="row dashrowfix">
                <div class="col m12 s12 martneg10">
                    <h5 class="white-text">
                        <span class="col">Zone Libre / Occupé </span>
                    </h5>
                </div>
            </div>
            <div class="white">
                <chart class="dashchart" type="bar" [data]="stackedBarZoneData" [options]="stackedBaroptions"></chart>
            </div>
        </div>
    </div>
    <div class="col-6 m6 s12 mart10">
        <div class="mat-elevation-z4 white dashh1">
            <div class="row dashrowfix">
                <div class="col m12 s12 martneg10">
                    <h5 class="white-text">historique places </h5>
                </div>
            </div>
            <div class="white">
                <chart class="dashchart" type="line" [data]="mutiLineChartDataPlaces"
                    [options]="mutiLineChartDataoptions"></chart>
            </div>
        </div>
    </div>
    <div class="col-6 m6 s12 mart10">
        <div class="mat-elevation-z4 white dashh1">
            <div class="row dashrowfix">
                <div class="col m12 s12 martneg10">
                    <h5 class="white-text">
                        <span class="col">historique zones: </span>
                        <span class="col">
                            <select [(ngModel)]="mutiLineChartDataZonesType"
                                (change)="fillZoneHistoriqueGraph()">
                                <option *ngFor=" let zone of zones" [ngValue]="zone.id">
                                    {{zone.label}}
                                </option>
                            </select>
                        </span>
                    </h5>
                </div>
            </div>
            <div class="white">
                <chart class="dashchart" type="line" [data]="mutiLineChartDataZones"
                    [options]="mutiLineChartDataoptions"></chart>
            </div>
        </div>
    </div>
</div>